(function($, undefined) {
	'use strict';
	var utils;
	var lastInputTime = -1;
	var lastTimeoutId = -1;
	
	var init = function() {
		utils = Fw.component.models().utils;
		
		$('.autocomplete__input').on('input', utils.debounce(onAutocompleteInput, 250));
	};
	
	var onAutocompleteInput = function() {
		var input = $(this);
		var value = input.val();
		var ctn = input.closest('.autocomplete');
		
		if (input.hasClass('autocomplete-input_persons')) {
			if (value.length > 0) {
				ctn.addClass('autocomplete_processing');
				fetchPersons(value, (persons) => {
					if (persons.length > 0) {
						ctn.addClass('autocomplete_show-results');
						$('.autocomplete__results', ctn).empty();
						$('.autocomplete__results', ctn).append(personsTolistItems(persons));
					}
					else {
						ctn.removeClass('autocomplete_show-results');
					}
					ctn.removeClass('autocomplete_processing');
				});
			} 
			else {
				ctn.removeClass('autocomplete_show-results');
			}
		}
	};
	
	function fetchPersons(value, callback = () => {}) {
		var persons = [{"id": 1234, "firstName": "Gabrielle", "lastName": "Bastien"}, {"id": 7777, "firstName": "Andréanne", "lastName": "Lévesque"}];
		var filteredResults = persons.filter((person) => {
			var found = false;
			for (var k in person) {
				if (person.hasOwnProperty(k) && fuzzyMatch(value, person[k].toString())) {
					found = true;
				}
			}
			return found;
		});
		callback(filteredResults);
	}
	
	function personsTolistItems(persons = []) {
		var list = $("<ul></ul>");
		for (var i in persons) {
			var person = persons[i];
			list.append($(`<li data-id="${person.id}">${person.firstName} ${person.lastName}</li>`));
		}
		return $('li', list);
	}
	
	function fuzzyMatch(pattern, str) {
		pattern = utils.removeLowercaseDiacritics(pattern.toLowerCase());
		str = utils.removeLowercaseDiacritics(str.toLowerCase());
		pattern = '.{0,3}' + pattern.split('').join('.{0,3}') + '.{0,3}';
		const re = new RegExp(pattern, 'i');
		return re.test(str);
	}
	
	$(window).ready(function() {
		init();
	});
})(jQuery);
